/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.0279 9.2A7.5212 7.5212 0 0 0 9.3 9c-4.05 0-7.3504 3.2104-7.495 7.2251l-.005.275v2.4c0 .7766.5903 1.4154 1.3466 1.4922l.1534.0078h3.3v-6.9c0-1.8226 1.4774-3.3 3.3-3.3h3.4711a7.4586 7.4586 0 0 0-2.3432-1Zm2.0657-2.2785A4.4786 4.4786 0 0 0 13.8 4.5c0-2.4853-2.0147-4.5-4.5-4.5S4.8 2.0147 4.8 4.5a4.479 4.479 0 0 0 .7064 2.4215c.1906.298.4153.572.6687.8166a9.2436 9.2436 0 0 0-.985.417C2.1153 9.6724 0 12.8392 0 16.5001v2.4l.006.201c.104 1.7289 1.539 3.099 3.294 3.099h3.6598c.5462 1.0685 1.6577 1.8 2.9402 1.8h10.8c1.8225 0 3.3-1.4775 3.3-3.3v-7.2c0-1.8226-1.4775-3.3-3.3-3.3h-4.5588a9.3301 9.3301 0 0 0-2.7314-2.045 9.2333 9.2333 0 0 0-.9849-.417 4.521 4.521 0 0 0 .6687-.8167Zm1.0428 8.415.0872-.101a.9002.9002 0 0 0-1.36-1.1718l-3.0304 3.0304 3.0244 3.0821.1002.0881a.9002.9002 0 0 0 1.1726-.076l.0881-.1002c.2647-.3498.2404-.8501-.0761-1.1726l-1.7751-1.8107 1.7691-1.7683ZM20.4 17.0941l-3.0245 3.0821-.1001.0881a.9002.9002 0 0 1-1.1726-.076l-.0881-.1002a.9001.9001 0 0 1 .0761-1.1726l1.7751-1.8106-1.7692-1.7684-.0871-.101c-.2614-.3523-.2324-.8523.0871-1.1718a.9.9 0 0 1 1.2728 0L20.4 17.0941ZM9.3 1.8001c1.4912 0 2.7 1.2087 2.7 2.7 0 1.491-1.2088 2.7-2.7 2.7S6.6 5.991 6.6 4.5c0-1.4913 1.2088-2.7 2.7-2.7ZM20.7 12H9.9c-.8285 0-1.5.6715-1.5 1.5v7.2c0 .8284.6715 1.5 1.5 1.5h10.8c.8284 0 1.5-.6716 1.5-1.5v-7.2c0-.8285-.6716-1.5-1.5-1.5Z"
    clipRule="evenodd"
  />,
  'MenuDevPortal'
);
